<ng-container *ngIf="tableData">
  <div [ngClass]="{ 'card-panel': tableData.infoTableSectionTitle }">
    <div class="p-3" *ngIf="tableData.infoTableSectionTitle">
      <app-section-title
        [sectionTitleConfig]="tableData.infoTableSectionTitle"
      ></app-section-title>
    </div>
    <div
      *ngFor="let infoTableData of tableData.infoTableData"
      [ngClass]="{'pb-4 px-3 px-lg-5 ': tableData.infoTableSectionTitle}"
    >
      <h4>{{ infoTableData.cardHeader }}</h4>
      <div class="card-panel" [ngStyle]="{'background-color': tableData.infoTableBackground.backgroundColor}">
        <div class="card-body">
          <div
            class="table-responsive"
            *ngFor="let header of infoTableData.headers;let i = index">
            <table class="table table-striped info-table {{tableName}}">
              <thead>
              <tr>
                <th scope="col" *ngFor="let headerKey of header | keyvalue : originalOrder">
                  {{ headerKey.value }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let rows of infoTableData.data; let j = index"
                  [ngStyle]="{'background-color': tableData.infoTableBackground.rowColor}">
                <td
                  *ngFor="let rowKey of infoTableData.data[j] | keyvalue : originalOrder;
                  let last = last; let i = index">
                  <div class="fieldgroup" *ngIf="rowKey.value.type == 'inputtext'">
                    <mat-form-field [style.width.px]=115>
                      <mat-label>{{rowKey.value.placeholder}}</mat-label>
                      <input
                        matInput
                        type="text"
                        id="{{ rowKey.key }}{{ i }}"
                        class=""
                        value="{{ rowKey.value.value }}"
                        name="{{ rowKey.key }}"
                        placeholder=""
                        [disabled]="enterKHD"
                      />
                    </mat-form-field>

                    <span class="error hidden">{{rowKey.value.error}}</span>
                  </div>
                  <div class="textgroup" *ngIf="rowKey.value.type == 'text'">
                    <input type="hidden" name="{{rowKey.key}}" value="{{rowKey.value.value}}">
                    <span class="{{ rowKey.key }}">{{rowKey.value.value}}</span>
                  </div>
                  <div class="textgroup" *ngIf="rowKey.value.type == 'checkbox'">
                    <mat-checkbox class="example-margin" name="{{rowKey.key}}"></mat-checkbox>
                  </div>

                  <div class="textgroup" *ngIf="rowKey.value.type == 'KHD'">
                    <mat-checkbox name="{{rowKey.key}}" [(ngModel)]="enterKHD" [checked]="rowKey.value.value"
                    (change)="onUploadCheck($event)">
                      Επισύναψη Τοπογραφικού Διαγράμματος εν απουσία ΚΗΔ
                    </mat-checkbox>
                    <div class="row">
                      <app-button [label]="'Μεταφόρτωση'"
                        [actionCallback]="rowKey.value.actionCallback"
                        [disabled]="!enterKHD"
                      ></app-button>
                      <app-button [disabled]="!enterKHD"
                                  [label]="'Προβολή'"
                                  [actionCallback]="rowKey.value.downloadCallback">
                        <span style="font-size: small">Προβολή</span>
                      </app-button>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12">
            <div class="col-12 col-lg-12">
              <app-success-message [MessageTitle]="">
                <span class="qrcode-value">
                  <br />
                  Σε περίπτωση που έχετε χρησιμοποιήσει Τοπογραφικό Διάγραμμα που
                  <b>δε φέρει Κωδικό Ηλεκτρονικού Διαγράμματος (Κ.Η.Δ.)</b>
                  παρακαλείστε όπως <b>μεταφορτώσετε Τοπογραφικό Διάγραμμα</b>.
                  <br />
                  <br />
                  Η ενότητα Συνοδευτικά Έγγραφα είναι προαιρετική και συμπληρώνεται μόνο
                  στην περίπτωση που είτε ο Κωδικός Ηλεκτρονικού Διαγράμματος (Κ.Η.Δ.)
                  είτε το Τοπογραφικό Διάγραμμα είναι απαραίητα για τη διεκπεραίωση της
                  τρέχουσας πράξης μεταβίβασης.
                  <br />
                  <br />
                </span>
              </app-success-message>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-container>
